export class VenueModel{
    public name = '';
}